import { useAuth } from "../../../usercontext";
import GlobalCurriculumTable from "../../pages/common/globalcurriculumtable";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentCurriculumTable() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="CurriculumTable" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="CurriculumTable" />}
			<PageNotes type={'Student'} studentId={slug} />
			<div className="col-12">
				<div className="settings-widget">
					<div className="settings-inner-blk p-0">
						<GlobalCurriculumTable slug={profile.id} isStudent={true} />
					</div>
				</div>
			</div>
		</>
	)
}
